import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import StoreEvent from "./modules/store-event";
import StorePeople from "./modules/store-people";
import StoreTask from "./modules/store-task";
import settings from "@/settings";
import router from "./../router";
Vue.use(Vuex);

let default_user_data = {
    kids_count: 0,
    email: null,
    trial: null,
    password: null,
    authorization_method: "email",
    facebook_id: null,
    phone: null,
    country_code: null,
    address: null,
    full_name: null,
    remember_me: false
};

export default new Vuex.Store({
    modules: {
        StoreEvent,
        StoreTask,
        StorePeople
    },
    state: {
        pricing_plans: [],
        errors: [],
        general_errors: [],
        user_data_loaded: false,
        active_tab: "toc",
        is_logged_in: window.app.pageData.is_logged_in,
        password_reset_sent: false,
        user_save_success: false,
        client_token: null,
        user: {
            active_subscriptions: [],
            active_plan: {},
            username: null,
            kids_count: 0,
            name: null,
            message: null,
            trial: null,
            email: null,
            facebook_email: null,
            password: null,
            authorization_method: "email",
            facebook_id: null,
            remember_me: false,
            full_name: null,
            address: null,
            country_code: null,
            phone: null
        },
        current_view_title: null
    },
    mutations: {
        set_user(state, user) {
            state.user = user;
            state.user_data_loaded = true;
        },
        set_is_logged_in(state, bool) {
            state.is_logged_in = bool;
        },
        set_active_subscriptions(state, subs) {
            state.user.active_subscriptions = subs;
        },
        set_username(state, name) {
            state.user.username = name;
        },
        set_client_token(state, token) {
            state.client_token = token;
        },
        set_active_plan(state, plan) {
            state.user["active_plan"] = plan;
        },
        set_user_data_success(state, name) {
            state.user_save_success = name;
        },
        set_active_tab(state, tab) {
            state.active_tab = tab;
        },
        update_field(state, { prop_name, prop_value }) {
            state.user[prop_name] = prop_value;
        },
        set_global_errors(state, error) {
            state.general_errors = error;
        },
        set_errors(state, errors) {
            state.errors = errors;
        },
        set_pricing_plans(state, plans) {
            state.pricing_plans = plans;
        },
        clear_user(state) {
            state.user = JSON.parse(JSON.stringify(default_user_data));
        },
        set_password_reset_sent(state, bool) {
            state.password_reset_sent = bool;
        }
    },
    actions: {
        async login({ commit }, payload) {
            let email = payload.email ? payload.email.trim() : null;
            if (payload.authorization_method === "facebook") {
                email = payload.facebook_email ? payload.facebook_email.trim() : null;
            }
            try {
                let response = await axios.post(settings.api_url + "/user/login", {
                    email: email,
                    facebook_id: payload.facebook_id ? payload.facebook_id : null,
                    authorization_method: payload.authorization_method,
                    password: payload.password ? payload.password.trim() : null,
                    remember_me: payload.remember_me
                });
                let rd = response.data;
                if (rd && rd.redirect_url) {
                    commit("set_is_logged_in", true);
                    router.push({ path: rd.redirect_url });
                }
            } catch (error) {
                let step;
                if (error.data && error.data.errors) {
                    let length = error.data.errors.length;
                    for (step = 0; step < length; step++) {
                        let _error = error.data.errors[step];
                        commit("set_global_errors", _error.message);
                    }
                } else {
                    commit("set_global_errors", "Could not log in");
                }
            }
        },
        async get_pricing_plans({ commit }) {
            try {
                let response = await axios.post(settings.api_url + "/pricing-plans/", {});
                if (response && response.data) {
                    commit("set_pricing_plans", response.data.pricing_plans);
                    return true;
                }
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                }
                return false;
            }
        },

        async send_error_report({ commit }, payload) {
            try {
                let response = await axios.post(settings.api_url + "/error/", {
                    description: payload.description ? payload.description.trim() : null
                });
                let rd = response.data;
                if (rd && rd.success) {
                    router.go(-1);
                }
            } catch (error) {
                let step;
                if (error.data && error.data.errors) {
                    let length = error.data.errors.length;
                    for (step = 0; step < length; step++) {
                        let _error = error.data.errors[step];
                        commit("set_global_errors", _error.message);
                    }
                } else {
                    commit("set_global_errors", "Could not send error report");
                }
            }
        },
        async get_logged_in_user({ commit }) {
            let args = {
                action: "get_logged_in_user"
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        commit("set_is_logged_in", rd.logged_in);
                        commit("set_username", rd.user_email);
                        commit("set_user", rd.user);
                        commit("set_client_token", rd.client_token);
                        commit("set_active_plan", rd.active_plan);
                        commit("set_active_subscriptions", rd.active_subscriptions);
                    }
                }
            } catch (error) {}
            return true;
        },
        async save_user({ commit }, payload) {
            let args = {
                action: "update_user",
                email: payload.email ? payload.email : null,
                country_code: payload.country_code ? payload.country_code : null,
                address: payload.address ? payload.address : null,
                phone: payload.phone ? payload.phone : null,
                first_name: payload.first_name ? payload.first_name : null,
                last_name: payload.last_name ? payload.last_name : null
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        commit("set_user_data_success", true);
                        commit("set_user", rd.user);
                    }
                }
            } catch (error) {
                commit("set_user_data_success", false);
            }
            return true;
        },
        async delete_user({ commit }) {
            let args = {
                action: "delete_user"
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        commit("set_is_logged_in", false);
                        router.push({ path: "/login" });
                        window.location.reload();
                    }
                }
            } catch (error) {}
            return true;
        },
        async add_free_trial({ commit }) {
            let args = {
                action: "add_free_trial"
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        router.push({ path: "/settings/subscription/success" });
                    }
                }
            } catch (error) {}
            return true;
        },

        async unsubscribe({ commit }) {
            let args = {
                action: "unsubscribe"
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        router.push({ path: "/settings/subscription/unsubscribe" });
                    }
                }
            } catch (error) {}
            return true;
        },

        async change_password({ commit }, payload) {
            let args = {
                action: "change_password",
                email: payload.email,
                h: payload.h,
                pw: payload.pw
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response && response.data.success) {
                    commit("set_is_logged_in", true);
                    router.push({ path: "/events" });
                }
            } catch (error) {
                let step;
                if (error.data && error.data.errors) {
                    let length = error.data.errors.length;
                    for (step = 0; step < length; step++) {
                        let _error = error.data.errors[step];
                        this.state.general_errors = _error.message;
                    }
                }
            }
        },

        async resend_activation_email({ commit }, payload) {
            let args = {
                action: "resend_activation_email",
                email: payload.email
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response && response.data.success) {
                }
            } catch (error) {}
        },
        async activate_user({ commit }, payload) {
            let args = {
                action: "activate_user",
                email: payload.email,
                h: payload.h
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response && response.data.success === 1) {
                    let user = {
                        ...this.user,
                        email: payload.email
                    };
                    commit("set_user", user);
                    commit("set_is_logged_in", true);
                    router.push({ path: "/events" });
                } else {
                    this.state.general_errors = "Activation link expired";
                }
            } catch (error) {}
        },

        async is_password_reset_hash_valid({ commit }, payload) {
            let args = {
                action: "is_password_reset_hash_valid",
                email: payload.email
            };
            let response = await axios.post(settings.api_url + "/user/", args);
            return response;
        },
        async signup({ commit }, payload) {
            let email = payload.email ? payload.email.trim() : null;
            if (payload.authorization_method === "facebook") {
                email = payload.facebook_email ? payload.facebook_email.trim() : null;
            }
            try {
                let response = await axios.post(settings.api_url + "/user/signup", {
                    email: email,
                    trial: payload.trial ? payload.trial : null,
                    first_name: payload.first_name ? payload.first_name : null,
                    last_name: payload.last_name ? payload.last_name : null,
                    facebook_id: payload.facebook_id ? payload.facebook_id : null,
                    authorization_method: payload.authorization_method,
                    password: payload.password ? payload.password.trim() : null
                });
                if (response && response.data.redirect_url) {
                    router.push({ path: response.data.redirect_url });
                }
            } catch (error) {
                let step;
                if (error.data && error.data.errors) {
                    let length = error.data.errors.length;
                    for (step = 0; step < length; step++) {
                        let _error = error.data.errors[step];
                        commit("set_global_errors", _error.message);
                    }
                } else {
                    commit("set_global_errors", "Could not register");
                }
            }
        },
        async forgot_password({ commit }, payload) {
            let args = {
                action: "send_forgot_password_email",
                email: payload.email
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response && response.data && response.data.success) {
                    commit("set_password_reset_sent", true);
                }
            } catch (error) {
                let step;
                if (error.data && error.data.errors) {
                    let length = error.data.errors.length;
                    for (step = 0; step < length; step++) {
                        let _error = error.data.errors[step];
                        commit("set_global_errors", _error.message);
                    }
                } else {
                    commit("set_global_errors", "Could not reset password");
                }
            }
        },
        async user_logout({ commit }) {
            let data = {};
            try {
                let response = await axios.post(settings.api_url + "/user/logout", data);
                if (response && response.data && !response.data.logged_in) {
                    commit("set_is_logged_in", false);
                    router.push({ path: "/login" });
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
});
